export const firebaseConfigDEV = {
  apiKey: 'AIzaSyDUTmyc16ae5pjqn6RZNX-XlYoeHkSFaGM',
  appId: '1:662879337496:web:d48ff6e0b1001d87c6976d',
  authDomain: 'stylio-dev.firebaseapp.com',
  measurementId: 'G-ZV349FSEP2',
  messagingSenderId: '662879337496',
  projectId: 'stylio-dev',
  storageBucket: 'stylio-dev.firebasestorage.app',
}

export const firebaseConfigPROD = {
  apiKey: 'AIzaSyDSEvm7Brapork0YYsVvcsVZhlSGuhCLDc',
  authDomain: 'stylio-prod.firebaseapp.com',
  projectId: 'stylio-prod',
  storageBucket: 'stylio-prod.firebasestorage.app',
  messagingSenderId: '985598286622',
  appId: '1:985598286622:web:d849fb98678e634739870f',
  measurementId: 'G-L6BYKFFGRW',
}
